import { Box, Typography } from '@mui/material';

interface FieldLabelProps {
  children: string;
  required?: boolean;
  /** Color for the required asterisk indicator (defaults to error.main) */
  asteriskColor?: string;
  /** Fades the label to match a disabled field below it */
  disabled?: boolean;
}

/** Label above field — matches Figma pattern */
export default function FieldLabel({ children, required, asteriskColor, disabled }: FieldLabelProps) {
  return (
    <Typography variant="body2" fontWeight={500} fontSize={13} sx={{ mb: 0.5, color: disabled ? 'text.disabled' : '#616161' }}>
      {children}
      {required && (
        <Box component="span" sx={{ color: asteriskColor ?? 'error.main', ml: 0.25 }}>
          *
        </Box>
      )}
    </Typography>
  );
}
